
/* injects from baggage-loader */

export const getGameData = (data) => {
    return Object.values(data)
        .reduce((acc, curr) => {
            const {info: {horse_xml: { EventId: eventId, RacingId: racingId }}, creation_source} = curr;
            if (creation_source === 2) {
                acc[racingId] = {...curr, racingId};
            } else {
                acc[eventId] = {...curr, eventId};
            }
            return acc;
        }, {});
};